export default {
  apiUrl: "https://api.suomalainen-app.com"
};
